import {
  INSTITUTION_LOGIN_URL,
  INSTITUTION_FORGOT_PASSWORD_URL,
  INSTITUTION_RESET_TOKEN_VERIFICATION_URL,
  INSTITUTION_RESET_PASSWORD_URL
} from "../../apiurls/apiurls";

export const institutionLogin = async (loginData) => {
  try {
    const response = await fetch(INSTITUTION_LOGIN_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(loginData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw error;
  }
};

export const institutionForgotPasswordCall = async (email, url) => {
  try {
    const response = await fetch(INSTITUTION_FORGOT_PASSWORD_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, url }),
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.error || errData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("ForgotPasswordCall error:", error);
    throw error;
  }
};

export const institutionResetTokenVerificationCall = async (reset_token) => {
  try {
    const response = await fetch(INSTITUTION_RESET_TOKEN_VERIFICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ reset_token }),
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.error || errData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("ResetTokenVerificationCall error:", error);
    throw error;
  }
};

export const institutionResetPasswordCall = async (change_password_token, new_password) => {
  try {
    const response = await fetch(INSTITUTION_RESET_PASSWORD_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ change_password_token, new_password }),
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.error || errData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("ResetPasswordCall error:", error);
    throw error;
  }
};
